import PhishingDashboard from './PhishingDashboard'

export default PhishingDashboard;
